"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = void 0;
exports.overrides = [
    'assert',
    'debug',
    'dir',
    'dirxml',
    'error',
    'group',
    'groupCollapsed',
    'groupEnd',
    'info',
    'log',
    'table',
    'time',
    'timeEnd',
    'timeStamp',
    'trace',
    'warn',
];
/**
 * Scrubs console messages if enabled.
 * Since these are transported elsewhere (and wrapped by other libraries),
 * we will override them first. For example, if LR is wrapping console
 * methods, they can still intercept the input, but the following will prevent
 * the messages from being displayed to the end user.
 */
function silence(c) {
    if (c === void 0) { c = console; }
    exports.overrides.forEach(function (method) {
        c[method] = function stub() {
            /* noop */
        };
    });
}
exports.default = silence;
//# sourceMappingURL=index.js.map